var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMalaga = function SvgMalaga(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#malaga_svg__a)",
    d: "M180 57.55v115.27c0 16.79-7.5 17.82-8.48 21.94-.63 2.67-.58 9.42-4.36 13.69-2.51 2.84-9.8 14.55-32.16 14.55s-29.65-11.71-32.16-14.55c-3.78-4.27-3.73-11.02-4.36-13.69-.98-4.12-8.48-5.15-8.48-21.94V57.55C90 52.52 109.64 47 135 47s45 5.52 45 10.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#malaga_svg__b)",
    d: "M135 150c24.853 0 45-4.477 45-10s-20.147-10-45-10-45 4.477-45 10 20.147 10 45 10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "malaga_svg__a",
    x1: 135,
    x2: 135,
    y1: 221.95,
    y2: 47.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2B91C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#61ADD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8FC5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B4D8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D1E7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E6F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F2F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "malaga_svg__b",
    x1: 135,
    x2: 135,
    y1: 149.88,
    y2: 130.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2990BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3194C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4AA1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA4CB"
  })))));
};
export default SvgMalaga;